import { render, staticRenderFns } from "./ProcessMethod.vue?vue&type=template&id=79bf9d12&"
import script from "./ProcessMethod.vue?vue&type=script&lang=js&"
export * from "./ProcessMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports